import { InputHTMLAttributes, ReactNode, useEffect, useState } from "react";
import { UseFormClearErrors, UseFormRegisterReturn, UseFormSetValue } from "react-hook-form";
import { Button, Table } from "flowbite-react";

import ApiService from '../../../services/ApiServiceClass';
import InformationTag from "../../InfoTag/InfoTag";
import { RequestItemType, initialRequestItem } from "./RequestItemType";

import { useGetItemsByRequestID } from '../../../hooks/RequestItems/useGetItemsByRequestID';
import { useLoader } from '../../../hooks/useLoader';
import TableRow from "./TableRow";
import CustomYesNoModal from "../../Modals/CustomYesNoModal";
import { useManageRequest } from "./useManageRequest";
import UpdateItemsFormModal from "./UpdateItemsFormModal";
import { CiSquarePlus } from "react-icons/ci";

interface RequestItemFieldProps extends InputHTMLAttributes<HTMLInputElement> {
    itemNumber?: number;
    requestID?: string | null;
    registerItemizedField: UseFormRegisterReturn;
    setItemizedFieldValue: UseFormSetValue<any>;
    clearItemizedFieldErorrs: UseFormClearErrors<any>;
    labelName?: ReactNode;
    infoTagMessage?: string | " ";
    fieldName: string | "field";
    errorsItemizedField?: Record<string, any>; // Form state errors
}


const RequestItemField = ({registerItemizedField, requestID, setItemizedFieldValue, clearItemizedFieldErorrs, labelName, fieldName, errorsItemizedField,infoTagMessage, itemNumber, ...rest}: RequestItemFieldProps) => {
    const request_id: number = requestID !== null && requestID !== undefined ? parseInt(requestID) : 0;
    const { requestItems, setRequestItems, handleDeleteItem, computeItemsTotalCosts, fetchItems } = useManageRequest(request_id);
    const [selectedItemID, setSelectedItemID] = useState(0);
    const [selectedItem, setSelectedItem] = useState<RequestItemType>(initialRequestItem);
    const [openDeleteItemModal, setOpenDeleteItemModal] = useState(false);
    const [openUpdateItemModal, setOpenUpdateItemModal] = useState(false);
    const [currentAction, setCurrentAction] = useState<string>("add");

    const editItem = (id: number, item: RequestItemType) => {
        setSelectedItem(item);
        setSelectedItemID(id);
        setCurrentAction("edit");
        setOpenUpdateItemModal(true);
    }

    const addItem = () => {
        setCurrentAction("add");
        setOpenUpdateItemModal(true);
    }

    const handleDownload = async (id:number, fileName: string) => {
        try {
            const response = await ApiService.downloadFile(id);

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch(error) {    
            console.log(error);
        }
    }

    const deleteItem = (id: number) => {
        setSelectedItemID(id);        
        setOpenDeleteItemModal(true);        
    }

    useEffect(() => {
        setItemizedFieldValue("totalCost", computeItemsTotalCosts());
        setItemizedFieldValue(registerItemizedField.name, requestItems.length);
    }, [requestItems]);
    return (
        <div className="mb-8">
            <div className="flex">
                <div className="flex-none w-5 text-sm">{itemNumber}.</div>
                <div className="text-sm grid grid-cols-2">
                    <div>{labelName}</div> 
                    <div className="ml-2"><InformationTag message={infoTagMessage} />
                </div>
            </div>
            </div>
            <div className="flex">
                <div className="flex-none w-5"></div>
                <div className="grow mt-3">
                    <input
                        {...rest}
                        {...registerItemizedField}
                    />

                    <Table hoverable>
                        <Table.Head>
                            <Table.HeadCell>Name</Table.HeadCell>
                            <Table.HeadCell>Supplier</Table.HeadCell>
                            <Table.HeadCell>PartNo/SKU</Table.HeadCell>
                            <Table.HeadCell>Price</Table.HeadCell>
                            <Table.HeadCell>URL</Table.HeadCell>
                            <Table.HeadCell align='center'>Quote</Table.HeadCell>
                            <Table.HeadCell>
                                <span className="sr-only">Edit & Delete</span>
                            </Table.HeadCell>
                        </Table.Head>

                        <Table.Body className="divide-y">
                            { requestItems.map((item, key) => {                                
                                return (
                                    <TableRow 
                                                RequestItems={item} editItem={() => editItem(item.id, item)} 
                                                handleDownload={() => handleDownload(item.quote.id, item.quote.filename)} 
                                                deleteItem={() => deleteItem(item.id)} 
                                                key={key} />
                                )
                            })}
                        </Table.Body>
                        
                    </Table>
                    
                    <div className="mt-5">
                        <Button size="xs" onClick={() => addItem()} color="blue">
                            <CiSquarePlus className="mr-2 h-5 w-5" />
                            Add Item
                        </Button>
                    </div>
                    {errorsItemizedField && errorsItemizedField[fieldName] && (
                        <div className="text-red-500 text-xs pt-2">{errorsItemizedField[fieldName].message}</div>
                    )}                    
                </div>
            </div>

                    <CustomYesNoModal 
                                openModal={openDeleteItemModal} 
                                setOpenModal={setOpenDeleteItemModal} 
                                message='Are you sure you want to delete this item?' 
                                yesAction={() => handleDeleteItem(selectedItemID, setOpenDeleteItemModal)} 
                    />

                    <UpdateItemsFormModal 
                        openModal={openUpdateItemModal}
                        setOpenModal={setOpenUpdateItemModal}
                        currentAction={currentAction}
                        selectedItemID={selectedItemID}
                        selectedItem={selectedItem}
                        requestID={request_id}
                        setRequestItems={setRequestItems}
                        fetchItems={fetchItems}
                    />

        </div>
    )
}

export default RequestItemField;